@if (bannerOpen) {
  <div class="hlx-consent-banner d-print-none" role="dialog" aria-live="polite" [attr.aria-label]="texts.title" data-testid="consent-banner">
    <div class="hlx-consent-text">
      <strong>{{ texts.title }}</strong>
      <p>{{ texts.body }}</p>
    </div>
    <div class="hlx-consent-buttons">
      <p-button [label]="texts.rejectAll" (onClick)="consent.rejectAll()" data-testid="consent-reject-all" />
      <p-button [label]="texts.acceptAll" (onClick)="consent.acceptAll()" data-testid="consent-accept-all" />
    </div>
  </div>
} @else if (consent.canChangeChoice) {
  <button type="button" class="hlx-consent-settings d-print-none" (click)="consent.openBanner()" data-testid="consent-settings">
    {{ texts.settings }}
  </button>
}
